import { render } from "./NotificationSettings.vue?vue&type=template&id=2ce23af2"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/user_profile/NotificationSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ce23af2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ce23af2', __exports__)) {
    api.reload('2ce23af2', __exports__)
  }
  
  module.hot.accept("./NotificationSettings.vue?vue&type=template&id=2ce23af2", () => {
    api.rerender('2ce23af2', render)
  })

}


export default __exports__